export default {
  selectedSvgElement: (state) => state.selectedSvgElement,
  svgElementToPreview: (state) => state.svgElementToPreview,
  previewPositionX: (state) => state.previewPositionX,
  previewPositionY: (state) => state.previewPositionY,
  svgWidth: (state) => state.svgWidth,
  svgHeight: (state) => state.svgHeight,
}
